// Generated by ReScript, PLEASE EDIT WITH CARE
/* @generated */
'use strict';

let RescriptRelay = require("rescript-relay/src/RescriptRelay.bs.js");

let Types = {};

let fragmentConverter = {"__root":{"":{"f":""}}};

function convertFragment(v) {
  return RescriptRelay.convertObj(v, fragmentConverter, undefined, undefined);
}

let Internal = {
  fragmentConverter: fragmentConverter,
  fragmentConverterMap: undefined,
  convertFragment: convertFragment
};

let Utils = {};

let node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SharedForSaleProperty_property",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PropertyImageGallery_property"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PropertyPrice_property"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ForSalePropertyAttributes_property"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SharedForSalePropertyStatus_property"
    }
  ],
  "type": "ForSalePropertyV5",
  "abstractKey": null
};

exports.Types = Types;
exports.Internal = Internal;
exports.Utils = Utils;
exports.node = node;
/* RescriptRelay Not a pure module */
